<template>
  <v-layout row justify-center>
    <v-dialog v-if="linkData" v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">insert_drive_file</v-icon>
            Link Log
          </span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-form ref="edit_link" data-vv-scope="edit_link" lazy-validation>
            <v-layout row wrap pb-3>
              <v-flex xs12>
                <v-textarea
                  box
                  height="400px"
                  :value="log"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'LinkLogModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['linkLogDialog', 'linkData', 'loading'],
  data () {
    return {
      dialog: this.linkLogDialog,
      log: '',
      dictionary: {
        en: {
          custom: {
            'edit_link.link': {
              required: 'Link required'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    linkLogDialog: {
      handler () {
        this.dialog = this.linkLogDialog
        if (this.dialog && this.linkData.id) {
          this.getLinkLog()
        }
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('linkLogDialog', this.dialog)
      }
    }
  },
  methods: {
    getLinkLog () {
      this.log = ''
      this.$parent.$emit('loading', true)
      this.$store.dispatch('LINK_LOG', this.linkData.id).then(res => {
        this.log = res.log
        this.$parent.$emit('loading', false)
      }, err => {
        console.log('login error', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('LINK_LOG ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    closeModal () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/link-log-modal/LinkLogModal.vue